<template>
  <main>
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_title_bill_retrospect_all">
          <img src="@/assets/icon-restaurant-bill.png" />
        </div>
        <h2 class="title_bill_retrospect_all">สร้างใบกำกับภาษี</h2>
      </div>

      <v-btn
        class="grad-primary-bg white--text titlefont_bill_retrospect_all"
        height="50"
        width="20%"
        @click="$router.push('/restaurant')"
      >
        ย้อนกลับ
      </v-btn>
    </div>

    <div class="py-8 px-8">
      <v-card class="px-16 py-8 mb-4">
        <h3>ข้อมูลใบเสร็จ</h3>
        <div class="mt-4">
          <span class="grey--text pr-16"
            >เลขที่ใบเสร็จ : {{ taxDetail.code }}
          </span>
          <span class="grey--text pr-16"
            >การชำระเงิน :
            {{
              taxDetail.payment_method == 0
                ? "สด"
                : taxDetail.payment_method == 1
                ? "โอน"
                : taxDetail.payment_method == 2
                ? "โครงการรัฐ"
                : "เดบิต / เครดิต"
            }}
          </span>
          <span class="grey--text pr-16"
            >ยอดชำระ : {{ formatNumber(taxDetail.total_price) }} บาท
          </span>
        </div>
      </v-card>

      <v-form @submit.prevent="createTaxInvoice(newData)">
        <v-card class="px-16 py-8 mb-4">
          <h3 class="mb-8">ข้อมูลใบเสร็จ</h3>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="ชื่อลูกค้า"
                v-model="newData.customer_name"
                type="text"
                maxlength="100"
                @keypress="isNumber($event)"
                onpaste="return false"
                color="primary"
                :rules="[(v) => !!v || 'กรุณากรอกชื่อลูกค้า']"
                required
                outlined
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="เลขที่ผู้เสียภาษี"
                v-model="newData.tax_number_cus"
                type="text"
                maxlength="100"
                @keypress="isNumber($event)"
                onpaste="return false"
                color="primary"
                :rules="[(v) => !!v || 'กรุณากรอกเลขที่ผู้เสียภาษี']"
                required
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="ที่อยู่"
                v-model="newData.address"
                type="text"
                maxlength="100"
                @keypress="isNumber($event)"
                onpaste="return false"
                color="primary"
                :rules="[(v) => !!v || 'กรุณากรอกที่อยู่']"
                required
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                label="ตำบล , อำเภอ , จังหวัด , รหัสไปรษณี"
                v-model="addressLast"
                :items="addressList"
                color="primary"
                hide-details="auto"
                :rules="[(v) => !!v || 'กรุณาเลือกที่อยู่']"
                @change="handleAddressSplit(addressLast)"
                required
                outlined
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="px-16 py-8 mb-4">
          <h3 class="mb-8">การแสดงข้อมูลในใบเสร็จ</h3>
     
          <v-radio-group v-model="newData.type_show_data">
            
            <div
              style="
                width: 70%;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >

              <v-radio id="radio1" label="รายการอาหาร" :value="0" />
              <v-radio
                id="radio2"
                label="ไม่แสดงรายการ เขียนรวมยอด “อาหารและเครื่องดื่ม”"
                :value="1"
              />
            </div>
          </v-radio-group>
        </v-card>

        <div class="d-flex justify-center">
          <v-btn color="#28AB28" class="white--text py-6 px-16" type="submit">
            ยืนยันการสร้างใบกำกับภาษี
          </v-btn>
        </div>
      </v-form>
    </div>
  </main>
</template>

<script>
import addresses from "@/assets/address/thailand.json";
import { HTTP } from "@/axios.js";
export default {
  name: "createtaxinvoice",
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      taxDetail: {},
      show: false,
      notShow: false,
      newData: {
        id: 0,
        customer_name: "",
        tax_number_cus: "",
        address: "",
        district: "",
        amphoe: "",
        province: "",
        zipcode: "",
        type_show_data: null,
        user_id: 0,
      },

      addressList: addresses.map(
        (address) =>
          address.district +
          ", " +
          address.amphoe +
          ", " +
          address.province +
          ", " +
          address.zipcode.toString()
      ),
      addressLast: "",
    };
  },
  methods: {
    async taxData() {
      HTTP.get(`POS/table/invoice-detaile/${this.$route.params.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      })
        .then((response) => {
          if (response.data.successful === true) {
            response.data.invoiceDetaile.create_taxinvoice_by
              ? this.$router.push(`/taxinvoice/${this.$route.params.id}`)
              : "";

            this.taxDetail = response.data.invoiceDetaile;
            this.newData = {
              id: this.$route.params.id,
              customer_name: this.taxDetail.customer_name,
              tax_number_cus: this.taxDetail.tax_number_cus,
              address: this.taxDetail.address,
              district: this.taxDetail.district,
              amphoe: this.taxDetail.amphoe,
              province: this.taxDetail.province,
              zipcode: this.taxDetail.zipcode,
              type_show_data: this.taxDetail.type_show_data,
              user_id: this.$store.state.userProfile.user_id,
            };

     

            this.addressLast =
              this.taxDetail.district +
              ", " +
              this.taxDetail.amphoe +
              ", " +
              this.taxDetail.province +
              ", " +
              this.taxDetail.zipcode.toString();
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
    formatNumber(value) {
    return new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  },
    handleAddressSplit(a) {
      let splitedAddress = a.split(",");
      this.newData.district = splitedAddress[0];
      this.newData.amphoe = splitedAddress[1];
      this.newData.province = splitedAddress[2];
      this.newData.zipcode = +splitedAddress[3];
    },
    async createTaxInvoice(data) {
  if (
    this.newData.customer_name !== "" &&
    this.newData.tax_number_cus !== "" &&
    this.newData.address !== "" &&
    this.newData.district !== "" &&
    this.newData.user_id !== "" &&
    this.newData.type_show_data !== null
  ) {
    HTTP.post("POS/table/invoice/save-data-taxinvoice", data, {
      headers: {
        Authorization: `Bearer ${this.$store.state.token}`,
      },
    })
      .then((response) => {
        if (response.data.successful === true) {
          this.$router.push(`/billinvoiceprint/${this.newData.id}`);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit("logOutSuccess");
          this.$router.push("/login");
        }
      });
  } else {
    console.error("กรุณากรอกข้อมูลให้ครบ");
  }
}

  },
  mounted() {
    this.taxData();
  },
};
</script>
